// components/ExperienceSection.jsx
import React from "react";

import imgTop from "../../assets/eventTop.jpg";
import imgBottom from "../../assets/eventBottom.jpg";

const ExperienceSection = () => {
  return (
    <section
      className="w-full px-6 md:px-12 lg:px-20 py-16 bg-white"
      data-aos="fade-up"
    >
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {/* Left Image */}
        <div data-aos="zoom-in" data-aos-delay="200">
          <img
            src={imgTop}
            alt="Luxury event"
            className="w-full h-auto object-cover rounded-2xl shadow-md"
          />
        </div>

        {/* Right Content */}
        <div
          className="flex flex-col space-y-6"
          data-aos="fade-left"
          data-aos-delay="300"
        >
          {/* Subtitle */}
          <p
            className="text-xs md:text-sm tracking-[0.3em] uppercase text-[#B9A68D] font-semibold"
            data-aos="fade-down"
            data-aos-delay="400"
          >
            Unforgettable Experience
          </p>

          {/* Main Heading */}
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-snug favela"
            data-aos="fade-right"
            data-aos-delay="500"
          >
            Five courses. <br />
            One conversation.
          </h2>

          {/* Description */}
          <p
            className="text-gray-600 text-base md:text-lg leading-relaxed max-w-xl"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            An indicative arc from brightness to texture, a signature
            centrepiece, a clean pause, and a restrained, satisfying finish
          </p>

          {/* Bottom Image */}
          <div data-aos="zoom-in" data-aos-delay="700">
            <img
              src={imgBottom}
              alt="Event celebration"
              className="w-full h-auto object-cover rounded-2xl shadow-md"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
